export const removeRepeatingForwardSlashes = (input: string): string =>
  input.replace(/\/{2,}/g, '/');

export const MFE = {
  COMMON: 'common',
  REGISTRY: 'registry',
  IPS_API_MARKETPLACE: 'apimarketplace',
  IPS_BUY_INFO: 'buy-info',
  IPS_REFUND: 'refund',
};

export const APIS = {
  KICKOFF: removeRepeatingForwardSlashes(
    `/api/authez/${process.env.REACT_APP_API_RELEASE}/${process.env.REACT_APP_API_VERSION}/ez/kickoff`,
  ),
  TOKEN: removeRepeatingForwardSlashes(
    `/api/authez/${process.env.REACT_APP_API_RELEASE}/${process.env.REACT_APP_API_VERSION}/ez/token`,
  ),
  MOCK_TOKEN: removeRepeatingForwardSlashes(
    `/api/mockez/${process.env.REACT_APP_API_RELEASE}/${process.env.REACT_APP_API_VERSION}/ez/token`,
  ),
  REGENERATE_TOKEN: removeRepeatingForwardSlashes(
    `/api/authez/${process.env.REACT_APP_API_RELEASE}/${process.env.REACT_APP_API_VERSION}/ez/token/regenerate`,
  ),
  REFRESH_TOKEN: removeRepeatingForwardSlashes(
    `/api/authez/${process.env.REACT_APP_API_RELEASE}/${process.env.REACT_APP_API_VERSION}/ez/token/refresh`,
  ),
  LOGOUT: removeRepeatingForwardSlashes(
    `/api/authez/${process.env.REACT_APP_API_RELEASE}/${process.env.REACT_APP_API_VERSION}/ez/logout`,
  ),
  SESSION: removeRepeatingForwardSlashes(
    `/api/authez/${process.env.REACT_APP_API_RELEASE}/${process.env.REACT_APP_API_VERSION}/ez/session`,
  ),
  SESSION_INFO: removeRepeatingForwardSlashes(
    `/api/authez/${process.env.REACT_APP_API_RELEASE}/${process.env.REACT_APP_API_VERSION}/ez/session/info`,
  ),
  INBOX_COUNT: removeRepeatingForwardSlashes(
    `/api/dashboard/${process.env.REACT_APP_API_RELEASE}/${process.env.REACT_APP_API_VERSION}/ez/inbox/messages/unreadCounts`,
  ),
  CART_COUNT: removeRepeatingForwardSlashes(
    `/api/cart/${process.env.REACT_APP_API_RELEASE}/${process.env.REACT_APP_API_VERSION}/ez/count`,
  ),
  SWITCH_PROFILE: removeRepeatingForwardSlashes(
    `/api/user/${process.env.REACT_APP_API_RELEASE}/${process.env.REACT_APP_API_VERSION}/ez/profile/switch`,
  ),
  TODO_LIST: removeRepeatingForwardSlashes(
    `/api/todo/${process.env.REACT_APP_API_RELEASE_PREV}/${process.env.REACT_APP_API_VERSION_PREV}/ez/items`,
  ),
  GET_USER_INFO: removeRepeatingForwardSlashes(
    `/api/user/${process.env.REACT_APP_API_RELEASE}/${process.env.REACT_APP_API_VERSION}/ez/profile`,
  ),
  GET_USER_PROFILE: removeRepeatingForwardSlashes(
    `/api/people/${process.env.REACT_APP_API_RELEASE_PREV}/${process.env.REACT_APP_API_VERSION_PREV}/ez/retrieve`,
  ),
  QI_CONTACT_INFO: removeRepeatingForwardSlashes(
    `/api/people/${process.env.REACT_APP_API_RELEASE_PREV}/${process.env.REACT_APP_API_VERSION_PREV}/ez/csp/qiProfile`,
  ),
  GC_CONTACT_INFO: removeRepeatingForwardSlashes(
    `/api/entity/${process.env.REACT_APP_API_RELEASE_PREV}/${process.env.REACT_APP_API_VERSION_PREV}/ez/groupOfCompanies/secretary/contactInfo`,
  ),
  POSITION_HOLDR_INFO: removeRepeatingForwardSlashes(
    `/api/entity/${process.env.REACT_APP_API_RELEASE_PREV}/${process.env.REACT_APP_API_VERSION_PREV}/ez/positionHolderInfo`,
  ),
  REGISTRY_PROFILE_DETAILS: removeRepeatingForwardSlashes(
    `/api/entity/${process.env.REACT_APP_API_RELEASE_PREV}/${process.env.REACT_APP_API_VERSION_PREV}/ez/csp/profileDetails`,
  ),
  CODES: removeRepeatingForwardSlashes(
    `/api/codes/${process.env.REACT_APP_API_RELEASE}/${process.env.REACT_APP_API_VERSION}/ez`,
  ),
  GET_ENTITY_INFO: removeRepeatingForwardSlashes(
    `/api/entity/${process.env.REACT_APP_API_RELEASE_PREV}/${process.env.REACT_APP_API_VERSION_PREV}/ez/entityInfo`,
  ),
  ENFORCEMENT_PAYMENT_DETAILS: removeRepeatingForwardSlashes(
    `/api/enforcement/${process.env.REACT_APP_API_RELEASE_PREV}/${process.env.REACT_APP_API_VERSION_PREV}/ez/payment`,
  ),
};

export const HEADER_URLS = {
  DASHBOARD: 'dashboard',
  INBOX_LISTING: 'inbox',
  CART: 'cart',
  PAYMENT_HISTORY: 'payment-history',
  PAYMENT_SETTINGS: 'payment-settings',
  MY_PROFILE: 'myprofile',
  ENTITIES: 'registry/manage/entity',
  MY_CSP: 'registry/maintenance-of-csp-client-list/my-csp',
  MY_CLIENTS: 'registry/maintenance-of-csp-client-list/my-client',
  MY_TRANSACTION: 'registry/transactions',
};

export const LOGIN_PAGE = {
  HEADING_1: 'Login to Bizfile',
  HEADING_2: 'Start your business registration, filing and information',
  INDIVIDUAL_USER: 'Login as Individual User',
  INDIVIDUAL_USER_DESCRIPTION: 'Login with your singpass',
  BUSINESS_USER: 'Login as Business User',
  BUSINESS_USER_DESCRIPTION: 'Login with UEN, or government corporate account',
  SINGPASS_BUTTON_LABEL: 'Login with your Singpass',
  CORPPASS_BUTTON_LABEL: 'Login with Corppass',
};

export const LOGOUT_MODAL = {
  INACTIVITY_TIMER_AUTH_USER: 1080000, // 18 minutes
  INACTIVITY_TIMER_PUB_USER: 86280000, // 23 hours 58 mins
  LOGOUT_TIMER: 120000, // 2 minutes
  LOGOUT_MAX_RETRIES: 3,
  EVENTS: ['click', 'keypress', 'scroll', 'mousemove'],
  LOGOUT_TITLE: 'Alert',
  LOGOUT_DESCRIPTION: 'Proceed to log out now?',
  ALREADY_LOGOUT_TITLE: 'Your session has ended',
  ALREADY_LOGOUT_MESSAGE:
    'You have been logged out due to activity in another tab with the same login credentials.',
  ALREADY_LOGOUT_DESCRIPTION: 'Please login again to continue your session.',
  INACTIVITY_TITLE: 'Your session will timeout soon',
  INACTIVITY_DESCRIPTION: 'Continue with this session?',
  CONFIRM_BTN_LABEL: 'Okay',
  LOGOUT_BTN_LABEL: 'Logout',
  CONTINUE_BTN_LABEL: 'Continue',
  CANCEL_BTN_LABEL: 'Cancel',
  BACK_TO_HOMEPAGE_LABEL: 'Back to homepage',
};

export const TOKEN_ERRORS = {
  REFRESH_COUNTER_EXCEEDED: 'AUTH-BUS-020',
  REFRESH_TOKEN_EXPIRED: 'AUTH-OAUTH-004',
  REFRESH_TOKEN_NOT_FOUND: 'LMBD-AUTH-000',
};

export const LOGIN_TYPE = {
  INDIVIDUAL: 'Individual',
  BUSINESS: 'Business',
};

export const HOME_PAGE_TABS = ['Entity', 'Industry', 'People', 'Reserved Name'];
export const POPULAR_ESERVICES_HEADERS = [
  'Register',
  'Manage',
  'Annual filing',
  'Buy information',
  'Subscribe APIs',
  'Download and authenticate',
];
export const POPULAR_ESERVICES_LINKS = {
  REGISTER: ['applyforNewBusiness', 'registerNewEntity', 'registerCorporate'],
  MANAGE: ['updateEntity', 'renewBusiness', 'appointWithDrawPosition'],
  ANNUAL_FILING: ['fileAnnualReturns', 'applyExemption', 'bizfinx'],
  BUY_INFORMATION: ['businessProfile', 'extracts', 'peopleProfile'],
  SUBSCRIBE_APIS: [
    'entityInfoQuery',
    'financialInfoQuery',
    'trustbarInfoQuery',
  ],
  DOWNLOAD_AUTH: [
    'downloadBiz',
    'trustBarAuthentication',
    'pdfProductAuthentication',
  ],
};

export const CAROUSEL_TITLES = {
  INFO_GUIDE: 'Information guides',
  START_BIZ: 'Starting your first business?',
  CHOOSE_BIZ: 'Choose a business structure',
  RESERVE_BIZ_NAME: 'Reserve a business name',
  REGISTER: 'Who needs to register',
  SOLE_PROPRIETORSHIP: 'Start a sole proprietorship',
  LOCAL_COMPANY: 'Incorporate a local company',
  BUY_INFORMATION: 'Buy business information',
  FILE_ANNUAL_RETURN: 'File annual returns',
  UPDATE_PARTICULAR: 'Update particulars of a company',
  REGISTRABLE_CONTROLS: 'Set up Register of Registrable Controllers',
};

export const CAROUSEl_SUBTITLES = {
  START_BIZ: 'We are here to help you navigate this exciting journey.',
  CHOOSE_BIZ:
    'Find out how to select a business entity type that best suits you.',
  RESERVE_BIZ_NAME:
    'Learn what are the key considerations when deciding on a business name.',
  REGISTER: 'Find out if you need to register your business.',
  SOLE_PROPRIETORSHIP:
    'Learn about this business entity type and how to start one.',
  LOCAL_COMPANY:
    'Learn about the requirements and process to incorporate a local company.',
  BUY_INFORMATION:
    'Find out how our business information products can empower your decision making.',
  FILE_ANNUAL_RETURN:
    'Find out when and how to file your company’s annual returns.',
  UPDATE_PARTICULAR:
    'Changes to your company’s shareholders or registered address? Learn how to update your changes in a timely manner.',
  REGISTRABLE_CONTROLS:
    'Find out what is a Register of Registrable Controllers and why you must set up one for your company.',
};

export const CAROUSEL_LINKS = {
  INFORMATION_GUIDES: 'https://www.acra.gov.sg/how-to-guides/',
  ANNUAL_FILLING:
    'https://www.acra.gov.sg/how-to-guides/filing-annual-returns-ars',
  CHOOSE_BIZ:
    'https://www.acra.gov.sg/how-to-guides/before-you-start/choosing-a-business-structure',
  RESERVE_BIZ:
    'https://www.acra.gov.sg/how-to-guides/before-you-start/reserving-a-business-name',
  BEFORE_START:
    'https://www.acra.gov.sg/how-to-guides/before-you-start/who-must-register',
  SP_PARTNERSHIP:
    'https://www.acra.gov.sg/how-to-guides/starting-sole-proprietorships',
  SETUP_COMPANY:
    'https://www.acra.gov.sg/how-to-guides/setting-up-a-local-company',
  UPDATING_PARTICULARS:
    'https://www.acra.gov.sg/how-to-guides/updating-information-of-companies-and-company-officers',
  BUYING_INFORMATION:
    'https://www.acra.gov.sg/how-to-guides/buying-information',
  RORC: 'https://www.acra.gov.sg/how-to-guides/setting-up-and-maintaining-register-of-registrable-controllers-(rorc)',
  GO_BUSINESS: 'https://www.acra.gov.sg/how-to-guides/buying-information',
  SME: 'https://www.imda.gov.sg/how-we-can-help/smes-go-digital',
  ESSENTIALS_STARTING_BIZ:
    'https://www.acra.gov.sg/training-and-resources/acra-academy/esb/essential-of-starting-a-business',
  DIRECTORS_TRAINING:
    'https://www.acra.gov.sg/training-and-resources/acra-academy/dtp/programme-details',
};

export const SEARCH_PLACEHOLDER = {
  ENTITY: 'Enter entity name or UEN to begin search',
  INDUSTY: 'Enter keywords or SSIC code to begin search',
  PEOPLE: 'Enter name or identification number to begin search',
  RESERVED_NAME:
    'Enter proposed business name to check against reserved business names',
};

export const INBOX_NOTIF = {
  LOADING_TIMER: 120000,
};

export const CART_NOTIF = {
  LOADING_TIMER: 120000,
  SUCCESS_LOADING_TIMER: 5000,
};

export const TEST_USER_ID = 'S9433661X';
export const TEST_UEN = '20239969X';

export const NO_SWITCH_PROFILE_MODAl = {
  TITLE: 'Unable to switch profile',
  DESCRIPTION: 'You do not have additional profiles to switch to.',
  BUTTON_LABEL: 'OK',
};

export const CRM_PUBLIC_PAGES = {
  PATH: '/crm/',
};

export const INDICATORS = ['cspIndicator', 'gcIndicator'];

export const ACCOUNT_SETTINGS = {
  TITLE: {
    label: 'Account Information',
    description:
      'An overview of your personal particulars and entity contact information.',
  },
  PARTICULARS: {
    label: 'User particulars',
  },
  ADDRESSES: {
    label: 'Addresses',
  },
  CONTACT: {
    label: 'Contact Information',
  },
  ALERT: {
    description:
      'You cannot edit personal information directly on this profile page. To update your details, please login as an Individual User via Singpass and access the ',
    cspNLabel: 'Update position holder information',
    cspNLink: removeRepeatingForwardSlashes(
      `${process.env.REACT_APP_BROWSER_ROUTER_BASENAME}/registry/update-personnel/edit-position-holder-instruction`,
    ),
    cspYLabel: 'Update registered qualified individual information',
    cspYLink: removeRepeatingForwardSlashes(
      `${process.env.REACT_APP_BROWSER_ROUTER_BASENAME}/registry/general-lodgement/instruction`,
    ),
    addtionalDesc: ' eService from the megamenu.',
  },
};
export const SESSION_MODAL_CONTENT = {
  title: 'Your session has expired',
  description: 'Please login again to continue your session.',
  buttonLabel: 'Back to homepage',
};

export const COMPLETION_PAGE_LABEL = {
  UEN: 'UEN',
  TRANSACTION_NO: 'Transaction ID',
  TRANSACTION_NAME: 'Transaction name',
  DATE_TIME: 'Datetime',
  GO_TO_DASHBOARD: 'Go to Dashboard',
};

export const ISHOP_LINKS = {
  VCC_PORTAL: 'https://www.vcc.bizfile.gov.sg/p/BuyInformation/IshopProducts',
  ACRA_DATA_POLICY:
    "https://www.acra.gov.sg/who-we-are/overview-of-acra#:~:text=ACRA's%20Data%20Policy%20Statement,-As%20the%20national&text=This%20is%20to%20facilitate%20trade,the%20people%20who%20operate%20them.",
  PRODUCT_DOWNLOAD: 'buy-info/download/product/verify',
  TRUSTBAR_AUTHENTICATE: 'https://www.acratrustbar.gov.sg/',
  PDF_PROD_AUTHENTICATE: 'buy-info/authenticate/pdf-product',
};

export const SPCP_ORIGIN = {
  SP: 'SP',
  CP: 'CP',
};

export const urlsToHideComponent = [
  { path: '/payment', queryParam: 'paymentKey' },
];

export const ROLES = {
  CORPPASS_AUTHENTICATED: 'CORPPASS_AUTHENTICATED',
  GOVT_AGENCY: 'GOVT_AGENCY',
  SINGPASS_AUTHENTICATED: 'SINGPASS_AUTHENTICATED',
  IPTO_UEN_USER: 'IPTO_UEN_USER',
  CSP_EMP: 'CSP_EMP',
  CSP_QI: 'CSP_QI',
  GC_SEC: 'GC_SEC',
  GC_EMP: 'GC_EMP',
  GC_GS: 'GC_GS',
};

export const CSP_ROLES = [ROLES.CSP_EMP, ROLES.CSP_QI];
export const GC_ROLES = [ROLES.GC_EMP, ROLES.GC_SEC, ROLES.GC_GS];
